import React, {useEffect} from 'react';

import { constCommon } from 'constants/constCommon';
import {
  useNavigate,
  useParams,
} from 'react-router-dom';
import {
    useRecoilState,
    useRecoilValue, useSetRecoilState,
} from 'recoil';
import {
  isAdmin,
  selectedMenu,
  subMenuState,
} from 'state';
import styled from 'styled-components';
import { textTransform } from 'util/textTransform';
import { SideMenuContainer } from 'view/components/container/SideMenuContainer';
import { MenuItem } from 'view/components/list/MenuItem';
import {cloneDeep} from "lodash";

const setMenuTitle = (title) => {
    switch (title) {
        case "Member Management":{
            return "Members"
        }
        default:{
            return title;
        }
    }
}
const isAdminState = sessionStorage.getItem('roleType') == "ROLE_ADMIN";
interface AdminSideMenuProps {
    isAdmin: boolean;
    onClick?:any
}
const isMobile = window.innerWidth < 768;

const AdminSideMenu: React.FC<AdminSideMenuProps> = (props) => {
    const navigate = useNavigate();
    const params = useParams();
    // const isAdminState = useRecoilValue(isAdmin)
    const [selected, setSelected] = useRecoilState(selectedMenu);
    const [selectedSubMenu ,setSelectedSubMenu] = useRecoilState(subMenuState);

    const onClickMenu = (title: string, menuClick: any) => {
        menuClick && menuClick();
    };

    const menuObj = (isAdmin: boolean) => {
        const menus = [
            {
                title: "Dashboard",
                subTitle:"",
                onClick: () => {
                    setSelected("Dashboard");
                    navigate("/main/dashboard")
                },
                icon: constCommon.ICON.SIDE_MENU.Dashboard,
            },
            isAdmin ? null : {
                title: "Profile",
                subTitle:selectedSubMenu,
                onClick: () => {
                    setSelected("Profile");
                    navigate("/main/profile")
                    setSelectedSubMenu("Author Profile")
                },
                depth: [
                    {
                        itemTitle: "Author Profile",
                        itemClick: () => {
                            navigate("/main/profile")
                            setSelectedSubMenu("Author Profile")

                        },
                    },
                    {
                        itemTitle: "Account Setting",
                        itemClick: () => {
                            navigate("/main/profile")
                            setSelectedSubMenu("Account Setting")
                        },
                    },
                ],
                icon: constCommon.ICON.SIDE_MENU.AvatarIcon,
            },
            !isAdmin ? null :  {
                title: "Member Management",
                subTitle:selectedSubMenu,
                onClick: () => {
                    setSelected("Whoflex Members");
                    navigate("/main/members")
                    setSelectedSubMenu("Instructor Application")
                },             
                depth: [
                    {
                        itemTitle: "Whoflex Members",
                        itemClick: () => {
                            navigate("/main/members")
                            setSelectedSubMenu("Whoflex Members")
                        },
                    },
                    {
                        itemTitle: "Whoflex Instructor",
                        itemClick: () => {
                            navigate("/main/members")
                            setSelectedSubMenu("Whoflex Instructor")
                        },
                    },
                    {
                        itemTitle: "Instructor Application",
                        itemClick: () => {
                            navigate("/main/members")
                            setSelectedSubMenu("Instructor Application")
                        },
                    },
                ],
                icon: constCommon.ICON.SIDE_MENU.Members,
            },
            {
                title: "Classes",
                subTitle:selectedSubMenu,
                onClick: () => {    
                    if(!isAdminState){                            
                        setSelected("Classes");
                        navigate("/main/classes")
                    }else{
                        setSelected("Classes");
                        navigate("/main/classes")
                        setSelectedSubMenu("In Progress")
                    }
                },
                depth: isAdmin
                    ? [
                          {
                              itemTitle: "In Progress",
                              itemClick: () => {
                                navigate("/main/classes")
                                setSelectedSubMenu("In Progress")
                                setSelected("Classes");

                              },
                          },
                          {
                              itemTitle: "Published",
                              itemClick: () => {
                                navigate("/main/classes")
                                  setSelectedSubMenu("Published")
                                setSelected("Classes");
                              },
                          },
                      ]
                    : null,
                icon: constCommon.ICON.SIDE_MENU.ClassesIcon,
            },
            {
                title: "Coaching",
                subTitle:selectedSubMenu,
                onClick: () => {    
                    if(!isAdminState){
                        setSelectedSubMenu("Products")
                        setSelected("Coaching");
                        navigate("/main/coaching")
                        // setSelectedSubMenu("Products")
                    }else{
                        setSelectedSubMenu("In Progress")
                        setSelected("Coaching");
                        navigate("/main/coaching")
                        /*setSelectedSubMenu("In Progress")*/
                    }
                },
                depth:isAdmin ? [
                    {
                        itemTitle: "In Progress",
                        itemClick: () => {
                            navigate("/main/coaching")
                            setSelected("Coaching");
                            setSelectedSubMenu("In Progress")
                        },
                    },
                    {
                        itemTitle: "Published",
                        subTitle: "Published",
                        itemClick: () => {
                            navigate("/main/coaching")
                            setSelected("Coaching");
                            setSelectedSubMenu("Published")
                        },
                    },
                        {
                            itemTitle: "Requested",
                            subTitle: "Requested",
                            itemClick: () => {
                                navigate("/main/coaching")
                                setSelected("Coaching");
                                setSelectedSubMenu("Requested")
                            },
                        },
                        {
                            itemTitle: "Completed",
                            itemClick: () => {
                                navigate("/main/coaching")
                                setSelected("Coaching");
                                setSelectedSubMenu("Completed")
                            },
                        },
                ]
                :
                [
                    {
                        itemTitle: "Products",
                        itemClick: () => {
                            navigate("/main/coaching")
                            setSelected("Coaching");
                            setSelectedSubMenu("Products")
                          },
                    },
                    {
                        itemTitle: "Requested",
                        subTitle: "Requested",
                        itemClick: () => {
                            navigate("/main/coaching")
                            setSelected("Coaching");
                            setSelectedSubMenu("Requested")
                        },
                    },
                    {
                        itemTitle: "Completed",
                        itemClick: () => {
                            navigate("/main/coaching")
                            setSelected("Coaching");
                            setSelectedSubMenu("Completed")
                        },
                    },
                ]
                ,
                icon: constCommon.ICON.SIDE_MENU.Coaching,
            },
            {
                title:"Live",
                subTitle:selectedSubMenu,
                onClick: () => {
                    setSelected("Live");
                    navigate("/main/live")
                    setSelectedSubMenu("Requested")
                },
                depth: [
                    {
                        itemTitle: "Requested",
                        itemClick: () => {
                            navigate("/main/live")
                            setSelectedSubMenu("Requested")
                        },
                    },
                    {
                        itemTitle: "Scheduled",
                        itemClick: () => {
                            navigate("/main/live")
                            setSelectedSubMenu("Scheduled")
                        },
                    },
                    {
                        itemTitle: "Completed",
                        itemClick: () => {
                            navigate("/main/live")
                            setSelectedSubMenu("Completed")
                        },
                    },
                ],
                icon: constCommon.ICON.SIDE_MENU.LiveIcon,
            },
            {
                title: "Communication",
                subTitle:selectedSubMenu,
                onClick: () => {    
                    setSelected("Communication");
                    navigate("/main/communication")
                    setSelectedSubMenu("Homework")
                },
                depth: [
                    {
                        itemTitle: "Homework",
                        itemClick: () => {
                            navigate("/main/communication")
                            setSelectedSubMenu("Homework")

                        },
                    },
                    {
                        itemTitle: "Reviews",
                        itemClick: () => {
                            navigate("/main/communication")
                            setSelectedSubMenu("Reviews")
                        },
                    },
                    {
                        itemTitle: "Q n As",
                        itemClick: () => {
                            navigate("/main/communication")
                            setSelectedSubMenu("Q n As")
                        },
                    },
                ],
                icon: constCommon.ICON.SIDE_MENU.Communication,
            },
        ];
        return menus;
    };
    // useEffect(() => {
    //
    // }, [selectedSubMenu]);
    return (
        <SideMenuContainer>
            <Container>
                {menuObj(isAdminState).filter(filterItem => filterItem !== null).map((item, index) => {
                    return (
                        <MenuItem
                            key={index}
                            depth={item?.depth}
                            icon={item.icon}
                            isActive={textTransform().capitalizeFirstLetter(params?.depth1) === setMenuTitle(item?.title)}
                            onClick={() => {
                                onClickMenu(item.title, item.onClick);
                            }}
                            title={item.title}
                            subTitle={item?.subTitle}
                        />
                    );
                })}
            </Container>
        </SideMenuContainer>
    );
};

const Container = styled.div`
    margin-top: 10px;
    width: 100%;
    
    padding-right: 5px;
`;

export { AdminSideMenu };
